// extracted by mini-css-extract-plugin
export var container = "_ms-0";
export var dotAnimation = "_ms-2";
export var dotsLoading = "_ms-1";